import React from "react";
import "../../styles/LearningStreams.css";  

const ComputerBasics = () => {
  const basicsData = [
    {
      id: 1,
      theme: "blue",
      title: "MS Office Suite (Word, Excel, PowerPoint)",
      // Image: Visual of spreadsheets or business documents on a laptop
      bgImg: "https://i.pinimg.com/736x/e7/69/6f/e7696fa9e56a89cbb90eca7c03b94914.jpg"
    },
    {
      id: 2,
      theme: "purple",
      title: "Email & Internet Skills",
      // Image: Close up of typing/sending an email communication
      bgImg: "https://images.unsplash.com/photo-1557200134-90327ee9fafa?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 3,
      theme: "green",
      title: "File Management & Cloud Storage",
      // Image: Cloud technology or data server concept
      bgImg: "https://images.unsplash.com/photo-1544396821-4dd40b938ad3?auto=format&fit=crop&w=800&q=80"
    },
    {
      id: 4,
      theme: "yellow",
      title: "Cybersecurity Basics for Everyday Use",
      // Image: Digital security, lock, or secure coding concept
      bgImg: "https://i.pinimg.com/736x/73/a6/97/73a697b01409cfaac1741b1962e8ddd0.jpg"
    }
  ];

  return (
    <section className="basics-section container">
      {/* Header Section */}
      <div className="text-center mb-5">
        <h2 className="basics-main-title">Computer Basics</h2>
        <h5 className="fw-bold mb-3">From Beginner to Confident User</h5>
        <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
          This course is perfect for students and professionals who want to build a strong foundation in computer usage.
        </p>
      </div>
      
      {/* 2x2 Grid */}
      <div className="row g-4">
        {basicsData.map((item) => (
          <div key={item.id} className="col-lg-6 col-md-12">
            <div 
              className="basics-card" 
              style={{ backgroundImage: `url(${item.bgImg})` }}
            >
              {/* Dynamic Overlay */}
              <div className={`basics-card-overlay overlay-${item.theme}`}></div>
              
              {/* Centered Content */}
              <div className="basics-card-content d-flex justify-content-center align-items-center h-100">
                <h3 className="basics-card-title text-center">
                  <span className={`basics-highlight highlight-${item.theme}`}>
                    {item.title}
                  </span>
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ComputerBasics;